import React, { useState } from 'react'
import { Table, DatePicker, Select } from 'antd'
const { RangePicker } = DatePicker

const LichSuNapRut = () => {
 
  const data = []

  const columns = [
    {
      title: 'Thời gian đề xuất',
      dataIndex: 'time',
      key: 'time',
      width: 150
    },
    {
      title: 'Loại hình giao dịch',
      dataIndex: 'betCount',
      key: 'betCount',
      width: 200
    },
    {
      title: 'Số tiền nhận thực tế',
      dataIndex: 'betAmount',
      key: 'betAmount',
      width: 150
    },
    {
      title: 'Ghi chú phê duyệt',
      dataIndex: 'validBet',
      key: 'validBet',
      width: 200
    },
    {
      title: 'Trạng thái giao dịch',
      dataIndex: 'result',
      key: 'result',
      width: 150
    },
    {
      title: 'Thao tác',
      dataIndex: 'result',
      key: 'result',
      width: 150
    }
  ]

  const [selectedForm, setSelectedForm] = useState('ALL')
  const [dates, setDates] = useState([null, null])



  const handleFormChange = value => {
    setSelectedForm(value)
  }

  const handleDateChange = dates => {
    setDates(dates)
  }

  return (
    <div className='box-history margin_top_none'>
      <div className='body-historys' style={{ padding: '20px' }}>
        <div className='flex-hinhthuc' style={{ marginBottom: '20px'}} >
          <div style={{flex: '1' }} className='selec-profile'>
            <label style={{fontSize:'14px'}}>Trạng thái: </label>
            <Select
              defaultValue={selectedForm}
              style={{ width: 120 }}
              onChange={handleFormChange}
            >
              <Select.Option value='ALL'>Toàn bộ</Select.Option>
              <Select.Option value='FORM_1'>Đang xử lý</Select.Option>
              <Select.Option value='FORM_2'>Thành công</Select.Option>
              <Select.Option value='FORM_2'>Thất bại</Select.Option>
            </Select>
          </div>

          <div style={{display:"flex", flex: '2'}} className='selec-bottom'>
          <label style={{fontSize:'14px'}}>Thời gian </label>
              <RangePicker
                value={dates}
                onChange={handleDateChange}
                format='MM/DD/YYYY' // Định dạng hiển thị của ngày tháng
                style={{ marginLeft: '8px' }}
              />
            
          </div>
          <div style={{ flex: '1', display: 'flex', justifyContent: 'flex-end'}}>
                <button type="submit" className="btn primary">Tìm kiếm</button>
              </div>
        </div>
        <p className='price-lose'>
          Tổng tiền rút: <span>0 THB</span>
        </p>
      </div>

      <div className='table-history'>
        <Table
          dataSource={data}
          columns={columns}
          pagination={false}
          rowKey='time'
          locale={{ emptyText: ' Không có bất kì thông tin nào' }}
        />
      </div>
    </div>
  )
}

export default LichSuNapRut
